import { T } from '@tf/utils';
import { useParams } from 'react-router-dom';

export const useApplicationNodeIdParam = () => {
	const params = useParams<'applicationNodeId'>();
	T.assertNotNullish(params.applicationNodeId, 'no applicationNodeId in url');

	const applicationNodeId = parseInt(params.applicationNodeId, 10);
	if (Number.isNaN(applicationNodeId)) {
		throw new Error('invalid applicationNodeId');
	}

	return applicationNodeId;
};

export const useApplicationStructureParams = () => {
	const { applicationConnectionKind } = useParams<'applicationConnectionKind'>();
	T.assertNotNullish(applicationConnectionKind, 'no applicationConnectionKind in url');

	return { applicationConnectionKind };
};

export const useApplicationFormParams = () => {
	const { formName, formHash } = useParams<'formName' | 'formHash'>();
	T.assertNotNullish(formName, 'no formName in url');
	T.assertNotNullish(formHash, 'no formHash in url');

	return { formName, formHash };
};
